export { arrayRemoveItems, arrayFirstItemOrNull, arrayRemoveDuplicates };

const arrayRemoveItems = <TItem>(target: TItem[], items: TItem[]): void => {
	for (const item of items) {
		arrayRemoveItem(target, item);
	}
};

const arrayRemoveItem = <TItem>(target: TItem[], item: TItem): void => {
	const index = target.indexOf(item);

	if (index === -1) {
		return;
	}

	target.splice(index, 1);
};

const arrayFirstItemOrNull = <TItem>(items: readonly TItem[]): TItem | null => {
	return items.length > 0 ? items[0] : null;
};

const arrayRemoveDuplicates = <TItem>(target: readonly TItem[]): TItem[] => {
	return [...new Set<TItem>(target).values()];
};
